import { render, staticRenderFns } from "./nested.vue?vue&type=template&id=8e3434d6&"
import script from "../descriptors/nested.js?vue&type=script&lang=js&"
export * from "../descriptors/nested.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports